import * as React from 'react';

import './ThankYou.page.scss';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ThankYou.messages';
import { Link } from 'react-router-dom';
import { GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';
import { clearStateByListOfKeys } from 'loopback-react-request';
import { CartModel, ConfigurationMainModel, OrderModel, TroughModel } from 'franke-trough-dependencies';
import { appSettings, createApiUrl } from 'src/config';

export interface ThankYouPageProps {
  checkout: GlobalPrivateState['checkout'];
  configuration: GlobalPrivateState['configuration'];
  dispatch: Function;
  order: GlobalPrivateState['order'];
  trough: GlobalPrivateState['trough'];
  authenticator: GlobalPrivateState['authenticator'];
}

export interface ThankYouPageState {
  order?: GlobalPrivateState['order']['result'];
  configuration?: GlobalPrivateState['configuration']['result'];
  redirect: boolean;
}


export class ThankYouPageComponent extends React.Component<ThankYouPageProps, ThankYouPageState> {
  constructor(props: ThankYouPageProps) {
    super(props);
    this.state = {
      order: props.order.result,
      configuration: props.configuration.result,
      redirect: false,
    };
  }

  componentDidMount() {
    if (!this.state.order && this.props.order.result) {
      this.setState({
        order: this.props.order.result
      });
    }
    if (!this.state.configuration && this.props.configuration.result) {
      this.setState({
        configuration: this.props.configuration.result
      });
    }

    clearStateByListOfKeys<CartModel | ConfigurationMainModel | OrderModel | TroughModel>(
      [ 'order', 'checkout', 'configuration', 'trough' ], {
      dispatch: this.props.dispatch,
      state: [ 
        this.props.checkout,
        this.props.configuration,
        this.props.trough,
      ],
    });
    
  }

  public render() {
    const accessToken = this.props.authenticator.accessToken && this.props.authenticator.accessToken.id;
    const apiUrl = createApiUrl(appSettings.config);

    return (
      <div className="thank-you-configuration-page d-flex justify-content-center align-items-center vh-100">
        {this.state.order && this.state.configuration && (
          <div className="container text-center">
            <div className="row">
              <div className="col-12 mb-4">
                <h3>
                  <FormattedMessage {...MESSAGES.thankYouHeadline} />
                </h3>
                <p>
                  <FormattedMessage {...MESSAGES.thankYouMessage} />
                </p>
                <p>
                  <FormattedMessage {...MESSAGES.thankYouOrder} /> <strong>{this.state.configuration ? this.state.configuration.sapNumber : ''}</strong>
                </p>
              </div>
              {/* <div className="col-6">
                <button className="btn w-100">
                  <FormattedMessage {...MESSAGES.thankYouPdfButton} />
                </button>
              </div>
              <div className="col-6">
                <button className="btn w-100">
                  <FormattedMessage {...MESSAGES.thankYouTenderDocuments} />
                </button>
              </div> */}
              <div className="col-12 mt-3">
                <div className="mb-3">
                  <a href={`${apiUrl}/Orders/${this.state.order.id}/configurationpdf?access_token=${accessToken}`} className="btn w-100 border" target="_blank">
                    <FormattedMessage {...MESSAGES.orderPdf} />
                  </a>
                </div>
                <div className="mb-3">
                  <a href={`${apiUrl}/Configurations/${this.state.configuration && this.state.configuration.id}/manufacturingpdf?access_token=${accessToken}`} className="btn w-100 border" target="_blank">
                    <FormattedMessage {...MESSAGES.manufacturingPdf} />
                  </a>
                </div>
                <div className="mb-3">
                  <a href={`https://kwcws3d.blob.core.windows.net/cdn/technical-drawings/${this.troughFilename}.pdf`} className="btn w-100 border" target="_blank">
                    <FormattedMessage {...MESSAGES.troughPdf} />
                  </a>
                </div>
                <Link to="/" className="btn btn-secondary w-100">
                  <FormattedMessage {...MESSAGES.thankYouOverviewButton} />
                </Link>
              </div>
            </div>
          </div>
        )}
        {/* {!this.state.order && (
          <Redirect to="/" />
        )} */}
      </div>
    );
  }

  private get troughFilename(): string | undefined | null {
    return this.state.configuration && this.state.configuration.selectedTrough && this.state.configuration.selectedTrough.trough.fileName;
  }
}

export const ThankYouPage = connect((state: GlobalPrivateState) => ({
  checkout: state.checkout,
  configuration: state.configuration,
  order: state.order,
  trough: state.trough,
  authenticator: state.authenticator,
}))(ThankYouPageComponent);

export default ThankYouPage;
